// components
import {
  styled,
  Box,
  BoxProps,
  Stack,
  StackProps,
  TableContainer,
  TableContainerProps,
  TableCell,
  TableCellProps,
  Typography,
  TypographyProps
} from '@mui/material';

export const StyledOpenRequestsStack = styled(Stack)<StackProps>(
  ({ theme }) => ({
    paddingBottom: theme.spacing(4),
    marginTop: theme.spacing(-2),
    flexDirection: 'row',
    gap: theme.spacing(2),
    justifyContent: 'space-between'
  })
);

export const StyledOpenRequestsTableBox = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  maxHeight: 'calc(100vh - 200px)',
  overflowY: 'auto',
  overflowX: 'hidden'
}));

export const StyledOpenRequestsTableContainer = styled(
  TableContainer
)<TableContainerProps>(() => ({
  overflow: 'visible',
  maxHeight: 'none'
}));

export const StyledOpenRequestsTableCell = styled(TableCell)<TableCellProps>(
  ({ theme }) => ({
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: theme.palette.background.paper
  })
);

export const StyledDateTypography = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    lineHeight: 'normal',
    paddingTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  })
);
